"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectFocusedInboxOption')(function selectFocusedInboxOption(isFocusedInboxEnabled, state) {
    var optionState = state.optionState;
    optionState.isEnabled = isFocusedInboxEnabled;
}));
//# sourceMappingURL=selectFocusedInboxOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-focused-option/lib/actions/selectFocusedInboxOption.js
// module id = 5091
// module chunks = 2